import React, {Fragment} from "react"

const CommentContent = [
    {
        avatar:"comment-1",
        authorName: "Rosalina Kelian",
        icon: "fal fa-reply",
        btnText: "Responder",
        date: "24th March 2022",
        icon2: "far fa-calendar-alt",
        desc: 'Para todos los activos es un trabajo técnico difícil y que consume mucho tiempo. Y, por supuesto, el resultado debe ser fluido y agradable - nos atrevemos a decir, incluso divertido - de desarrollar y mantener. Independientemente de si estás configurando una tienda para un nuevo comerciante.',
        margin: ''
    },
    {
        avatar:"comment-2",
        authorName: "Rosalina Kelian",
        icon: "fal fa-reply",
        btnText: "Responder",
        date: "24th March 2022",
        icon2: "far fa-calendar-alt",
        desc: "Construir una experiencia de cliente que será visitada por millones, el objetivo de Hydrogen es eliminar lo indiferenciado y complicado rápidamente y enfocarse en entregar valor al comerciante.",
        margin: "ml-130 ml-lg-30 ml-xs-0"
    },
    {
        avatar:"comment-3",
        authorName: "Rosalina Kelian",
        icon: "fal fa-reply",
        btnText: "Responder",
        date: "24th March 2022",
        icon2: "far fa-calendar-alt",
        desc: 'Desbloquear estas funcionalidades y hacer que todas funcionen bien juntas requirió que trabajáramos directamente con el equipo central de React para ayudar a definir y prototipar componentes de servidor; el ecosistema Vite para streaming del lado del servidor; el equipo Aurora de Google para integrar conformidad.',
        margin:""
    },
]

const BlogComment = () => {
    return (
        <Fragment>
            <ul className="comment-list list-none">
                {CommentContent.map((val, i)=>(
                    <li key={i} className={val.margin}>
                        <div className="comment-box">
                            <div className="comment-avatar">
                                <img src={`assets/img/blog/${val.avatar}.jpg`} alt="Img"/>
                            </div>
                            <div className="comment-content">
                                <h5>{val.authorName}
                                    <a href="#" className="reply"><i className={val.icon} /> {val.btnText}</a>
                                </h5>
                                <p className="fs-14 mb-15"><i className={val.icon2}/>
                                    {val.date}</p>
                                <p>{val.desc}</p>
                            </div>
                        </div>
                    </li>
                ))}
            </ul>
        </Fragment>
    )
}

export default BlogComment